let currency_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'currencies', name: 'currencies.list', component: () => import('./pages/Index.vue') },
      { path: 'currencies/create', name: 'currencies.create', component: () => import('./pages/Create.vue') },
      { path: 'currencies/:acronym/edit', name: 'currencies.edit', component: () => import('./pages/Edit.vue') }
    ]
  }
];

export default currency_routes;
